import React from "react";
import { Skeleton } from "antd";
import styled from "styled-components";

function StatBox({ icon, title, value, loading }) {
  return (
    <Box>
      {loading ? (
        <Skeleton active avatar paragraph={false} title={{ width: 70 }} />
      ) : (
        <>
          {icon}
          <Text>
            <Title>{title}</Title>
            <Value>{value}</Value>
          </Text>
        </>
      )}
    </Box>
  );
}

export default StatBox;

const Box = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  flex: 1;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-size: 12px;
  color: #666;
`;

const Value = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #052e67;
`;